import React, {useMemo} from 'react';
import {Button, Image} from 'antd-mobile';
import {ReactComponent as FireIcon} from '@/assets/icons/promotions/fire.svg';
import {useTranslation} from 'react-i18next';
import {PromotionEntryItem} from './type';
import {executePromotionAction} from './promotion-action';

interface PromotionCardProps {
  item: PromotionEntryItem;
  login: boolean;
  onDownloadApp: (modalImageUrl?: string) => void;
}

const PromotionCard = ({item, login, onDownloadApp}: PromotionCardProps) => {
  const {t} = useTranslation();
  const cardBg = useMemo(() => item.imageUrl || '/', [item.imageUrl]);
  const joinedCount = item.joinedCount ?? 134252;
  const showJoinedCount = item.entryId.startsWith('LEGACY:');

  return (
    <div className="relative flex h-[13rem] flex-none flex-col overflow-hidden rounded-xl pb-3">
      <Image
        src={cardBg}
        alt={item.title || t('promotionsV2.promotion')}
        className="absolute inset-0 h-full w-full bg-image"
        fallback={<div className="h-full w-full bg-image" />}
        fit="fill"
      />
      <div className="z-[1] flex items-end justify-between pr-3">
        <div className="rounded-br-[1rem] bg-white/50 px-3 py-1.5 text-xs font-bold capitalize text-t1">
          {item.title || t('promotionsV2.promotion')}
        </div>
        <div />
      </div>

      <div className="flex-1" />

      <div className="z-[1] flex items-center justify-between px-4">
        {showJoinedCount ? (
          <div className="flex items-center gap-1 text-white">
            <FireIcon className="size-3" />
            <span>
              {t('promotionsV2.joined', {
                num: joinedCount.toLocaleString('en-US'),
              })}
            </span>
          </div>
        ) : (
          <div />
        )}

        <Button
          className="flex w-[7.875rem] items-center justify-center rounded-full bg-white py-2.5 text-sm font-semibold leading-[normal] text-t1 before:rounded-full"
          onClick={() =>
            executePromotionAction(item, {
              login,
              onDownloadApp,
            })
          }>
          {t('promotionsV2.join')}
        </Button>
      </div>
    </div>
  );
};

export default PromotionCard;
